var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory-state font-12 color-150 bg-300 w500",class:_vm.inventoryState},[_vm._v(" "+_vm._s(_vm.renderInventoryStateText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }